import { cx, useAppVariant, useTranslations } from "@jugl-web/utils";
import { Lottie } from "@jugl-web/utils/utils/Lottie";
import { FC } from "react";
import notFoundAnimation from "./assets/not-found-animation.json";

export const TicketsNoResultsState: FC = () => {
  const { isMobile } = useAppVariant();
  const { t } = useTranslations();

  return (
    <div className="flex h-full items-center justify-center p-6">
      <div
        className={cx(
          "flex flex-col items-center text-center",
          isMobile ? "max-w-[250px] gap-6" : "max-w-[500px] gap-8"
        )}
      >
        <Lottie
          options={{ animationData: notFoundAnimation }}
          width={150}
          height={150}
          className={cx(!isMobile && "-mb-6")}
        />
        <div className="flex flex-col items-center gap-2">
          <h2
            className={cx(
              "m-0 font-secondary leading-normal font-semibold text-dark",
              isMobile ? "text-xl" : "text-2xl"
            )}
          >
            {t({
              id: "client-support-page.no-results",
              defaultMessage: "No results",
            })}
          </h2>
          <p
            className={cx(
              "m-0 font-secondary leading-normal text-dark-700",
              isMobile ? "text-sm" : "text-base"
            )}
          >
            {t({
              id: "client-support-page.try-something-else",
              defaultMessage: "Try something else",
            })}
          </p>
        </div>
      </div>
    </div>
  );
};
